module.exports = __webpack_public_path__ + "static/media/Miwa.44ceee2b.png";